<tilby-dialog-toolbar title="SETTINGS.CASHMATIC.TITLE" (confirm)="confirm()"/>
<tilby-dialog-content>
    <tilby-magic-form [form]="cashmaticPaymentForm"/>
</tilby-dialog-content>